import type { Emitter } from 'mitt';
import mitt from 'mitt';

import type { EventHandler } from './PleasedSdk.types';

export class EventEmitter<R> {
  protected event: Emitter<{ [K in keyof R]: R[K] }> = mitt<{ [K in keyof R]: R[K] }>();
  on<E extends keyof R>(name: E, handler: EventHandler<R[E]>) {
    this.event.on(name, handler);
    return this;
  }
  off<E extends keyof R>(name: E, handler: EventHandler<never>) {
    this.event.off(name, handler as EventHandler<unknown>);
    return this;
  }
  once<E extends keyof R>(name: E, handler?: EventHandler<R[E]> | undefined): Promise<R[E]> {
    return new Promise((resolve) => {
      const callback = (data: R[E]) => {
        this.event.off(name, callback);
        resolve(data);
        handler?.(data);
      };
      this.event.on(name, callback);
    });
  }
}
